export const cookieNames = {
  checkbox_token: 'checkbox_token',
  access_token: 'access_token',
  refresh_token: 'refresh_token',
  trial_guid: 'trial_guid',
  region_id: 'region_id',
  active_step: 'active_step',
  up_for_renewal_dates: 'up_for_renewal_dates',
};
